module.exports = __webpack_public_path__ + "img/8d27c4cf0a1f01afc2dc520f508782b1.png";